module.exports = __webpack_public_path__ + "static/img/bg20.d885c0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg20.png
// module id = is92
// module chunks = 1